'use strict';

var u = require('react');
var A = require('styled-components');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var u__default = /*#__PURE__*/_interopDefault(u);
var A__default = /*#__PURE__*/_interopDefault(A);

var C=A__default.default.div`
`,L=({initialOpenIndexes:n=[],items:c=[],children:e=()=>null,gap:i="",isMultiOpen:s=!1})=>{let[a,l]=u.useState(n.reduce((r,o)=>({...r,[o]:!0}),{})),d=u.useCallback(({index:r})=>{l(o=>{let t={...s&&{...o}};return t[r]=!o[r],t});},[]);return u__default.default.createElement(C,{$gap:i},c.map((r,o)=>e(r,o,a[o]||!1,d)))};

exports.a = C;
exports.b = L;
